export default function InteractiveConsoleDescription() {
  return (
    <p>
      In order to easily and interactively query the REST endpoints of DISGENET as well as to get a detailed
      description of the input parameters and response format of each single endpoint, you can access the REST
      API Interactive Console. To authorize requests, paste your API key in the console header field
      (signed-in users can load it automatically). From then on, all calls sent from the console use that key
      in the <code>Authorization</code> header. The endpoint list stays in sync with the live API
      documentation.
    </p>
  );
}
